export enum EmployeePresent {
  OMTC = 1,
  VP = 2,
  ClientRel = 3,
  SVP = 4,
  Finance = 5,
  Other = 6,
}
